import { fetchAPI } from '../../helpers';
import AppContext from '../../AppContext';

class ZohoService {
    static searchInZoho = (search) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let token = appContext.getToken();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ZohoService}${platformId}/searchContact`,
            method: 'POST',
            body: {
                search
            }
        });
    }
}
export default ZohoService;